// Centralised constants used across the Faro frontend
export const FARO_LOGO = "/assets/logo-autoescuelas-faro.webp";
export const HEADER_LOGO = "/assets/logo-autoescuelas-faro-cabecera.webp";
export const HEADER_LOGO_BLUE = "#161692";

export const HERO_IMAGE = "https://images.unsplash.com/photo-1516862523118-a3724eb136d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkcml2aW5nJTIwc2Nob29sJTIwbGVhcm5lciUyMGRyaXZlcnxlbnwwfHx8fDE3ODExMjY1ODZ8MA&ixlib=rb-4.1.0&q=85";
export const LIFESTYLE_IMAGE = "/assets/permiso-por-puntos-conductor-vigo.webp";
export const TRUCK_IMAGE = "/assets/camion-practicas-autoescuelas-faro-vigo.webp";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COMPANY_EMAIL = "info@autoescuelasfaro.com";

// True while react-snap is capturing the static HTML (prerender build step)
export const IS_PRERENDER = typeof navigator !== "undefined" && /ReactSnap/.test(navigator.userAgent);

// Build the WhatsApp deep link using the center's phone
export function whatsappLink(phone, message = "Hola, me gustaría más información sobre Autoescuelas Faro") {
  const cleaned = String(phone).replace(/[^0-9]/g, "");
  const text = encodeURIComponent(message);
  return `https://wa.me/${cleaned}?text=${text}`;
}

// Format a whatsapp number ("34658790210") as a readable Spanish mobile ("658 790 210")
export function formatMobile(whatsapp) {
  const digits = String(whatsapp).replace(/[^0-9]/g, "");
  const local = digits.startsWith("34") ? digits.slice(2) : digits;
  return local.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
}

// ── Validación de teléfono español ─────────────────────────────────────────
// Reglas: exactamente 9 dígitos locales; se tolera prefijo "+34"/"0034"/"34"
// y separadores (espacios, guiones, paréntesis, puntos).
// Devuelve { ok: boolean, local: string, error: string|null }
export function validateSpanishPhone(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return { ok: false, local: "", error: "Introduce tu número de teléfono." };
  let digits = s.replace(/[\s.\-()]/g, "");
  if (digits.startsWith("+")) digits = digits.slice(1);
  if (digits.startsWith("0034")) digits = digits.slice(4);
  else if (digits.startsWith("34") && digits.length > 9) digits = digits.slice(2);
  if (!/^\d+$/.test(digits)) {
    return { ok: false, local: digits, error: "El teléfono solo puede contener números." };
  }
  if (digits.length < 9) {
    return { ok: false, local: digits, error: `Faltan dígitos: el teléfono debe tener 9 números (tiene ${digits.length}).` };
  }
  if (digits.length > 9) {
    return { ok: false, local: digits, error: `Sobran dígitos: el teléfono debe tener 9 números (tiene ${digits.length}).` };
  }
  return { ok: true, local: digits, error: null };
}

